import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { getUserProfile } from "../../redux/actions/userActions";
import { loadEvents } from "../../redux/actions/eventActions";
import { loadCities } from "../../redux/actions/cityActions";
import { updateSelectedCity } from "../../redux/actions/selectedCityActions";
import { updateDate } from "../../redux/actions/dateActions";
import { Calendar } from "react-calendar";
import "./ReactCalendar.css";
import "./CalendarPage.scss";
import DropDownSelect from "../common/DropDownSelect";

export default function CalendarPage(): Element {
  const events = useSelector(state => state.events);
  const cities = useSelector(state => state.cities);
  const date = useSelector(state => state.date);
  const selectedCity = useSelector(state => state.selectedCity ? state.selectedCity : "Hela Sverige");
  const { user, getAccessTokenSilently } = useAuth0();
  const userFromState = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [filteredEvents, setFilteredEvents] = useState(events);

  useEffect(() => {
    loadDate(localStorage.getItem("date"));
    getEvents();
    if (user && !userFromState.id) {
      getUser();
    }
  }, []);

  async function getEvents() {
    setFilteredEvents(await dispatch(loadEvents(date)).catch(error => {
      console.log(error);
    }));
  }

  const getUser = async () => {
    const accessToken = await getAccessTokenSilently();
    const data = await dispatch(getUserProfile(accessToken));
    console.log(data);
  };

  useEffect(() => {
    console.log("cities: ", cities);
    if (events.length >= 1 && cities.length <= 1 && cities[0].label == "Hela Sverige") {
      dispatch(loadCities()).catch(error => {
        console.log(error);
      });
    }
  }, [cities]);

  const navigate = useNavigate();
  async function routeChange(e) {
    await loadDate(e);
    navigate(`/eventlist`);
  }

  async function handleCityChange(selected) {
    await dispatch(updateSelectedCity(selected.value));
    if (selected.value === "Hela Sverige") {
      setFilteredEvents(events);
    } else {
      setFilteredEvents(events.filter(event => event.city === selected.value));
    }
  }

  const handleMonthChange = async newDate => {
    await loadDate(newDate.toLocaleString());
    console.log("Month changed to:", newDate.toLocaleString());
    dispatch(loadEvents(newDate.toLocaleString())).catch(error => {
      console.log(error);
    });
  };

  async function loadDate(newDate) {
    console.log(newDate);
    if (!newDate) return;
    await dispatch(updateDate(newDate.toLocaleString()));
    localStorage.setItem("date", newDate.toLocaleString());
  }

  function handleCreateEventClick() {
    navigate("/event");
  }

  return (
    <div className="calendarPage">
      <DropDownSelect
        choices={cities}
        selected={selectedCity}
        onChange={handleCityChange}
        label="Visa händelser i: "
      />
      <Calendar
        tileDisabled={({ date }) =>
          !filteredEvents.find(
            event =>
              new Date(event.startdate).toDateString() === date.toDateString()
          )
        }
        onChange={e => routeChange(e)}
        value={date}
        onActiveStartDateChange={({ activeStartDate }) =>
          handleMonthChange(activeStartDate)
        }
      />
      {user && (
        <button className="button" onClick={handleCreateEventClick}>
          Skapa händelse
        </button>
      )}
    </div>
  );
}
